export type ThemeClassName = "carson" | "itexchangenet" | "development" | "";
export function themeClassName(): ThemeClassName {
  let themeClassName: ThemeClassName = "";

  if (window.location.hostname === "carson-mcdowell.liquidacquire.com") {
    themeClassName = "carson";
  } else if (window.location.hostname === "itexchangenet.liquidacquire.com") {
    themeClassName = "itexchangenet";
  } else if (import.meta.env.DEV) {
    // Temporarily use IT ExchangeNet branding for local testing
    themeClassName = "itexchangenet";
  }

  return themeClassName;
}
